import type { IconSvgObject } from './types';

const ListEndIcon: IconSvgObject = [
  ["path", { d: "M2.99609 18H8.99609", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.9961 15C15.9961 15 12.9961 17.2095 12.9961 18C12.9961 18.7906 15.9961 21 15.9961 21M13.9961 18L14.9961 18C17.8245 18 19.2387 18 20.1174 17.1213C20.9961 16.2427 20.9961 14.8284 20.9961 12V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.99609 11H15.9961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2.99609 4H15.9961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ListEndIcon;
